module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/order-detail/order-detail.component.scss
// module id = ./src/app/components/account/order-detail/order-detail.component.scss
// module chunks = main